const {h, render, Component} = require('preact');

class Tabs extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let groupons = this.props.state.grouponsTab
    let gplus = this.props.state.gplusTab
    return (
      <div class="tabs-container">
        <ul class="tabs">
          <li class={groupons}>
            <a href="/customer_support" onClick={(e) => {this.props.switchTabs("my-groupons")}}>
               <span data-bhw="web2018_my_groupons_tab"
                     className="capitalize-text">{I18n.translate('js.modules.shared.my_groupons')}</span>
            </a>
          </li>
          <li class={gplus} >
            <a href="/customer_support/web/gplus" onClick={(e) => {this.props.switchTabs("my-gplus-deals")}}>
                <span data-bhw="web2018_my_gplus_tab"
                      className="capitalize-text">{I18n.translate('js.modules.support.my_gplus')}</span>
            </a>
          </li>
        </ul>
      </div>
    )
  }
}

module.exports = Tabs
